import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.CLEAR_RECENT_REQUEST:
      return {
        ...state,
        data: null,
        isProgress: true,
      };
    case homeConstants.CLEAR_RECENT_SUCCESS:
      return {
        data: action.response.success,
        isProgress: false,
      };
    case homeConstants.CLEAR_RECENT_FAILURE:
      return {
        data: null,
        error: action.error,
        isProgress: false,
      };
    default:
      return state;
  }
}
